module.exports = __webpack_public_path__ + "img/logo_name.238ff4b7.png";